module.exports = __webpack_public_path__ + "static/media/analytics.8d892229.jpg";